<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> {{ appVersion }}
  </div>
  Todos os direitos reservados SECONT-ES
</footer>